<template>
    <nav
        v-show="isNavBarVisible"
        class="top-0 left-0 right-0
                fixed flex bg-white min-h-[52px] flex-wrap
                border-b border-gray-300 z-30 w-screen
                transition-position w-auto items-stretch
                dark:bg-gray-900 dark:border-gray-900"
        :class="{'ml-0':isAsideMobileExpanded}"
    >
        <div class="flex-1 items-stretch flex h-[52px] pl-6">
            <nav-bar-item class="flex-grow">
                <router-link
                    to="/home"
                    class="inline-block"
                >
                    <img
                        class="h-7 my-auto md:block"
                        src="@/assets/img/spoplus_training_logo_02.png"
                    >
                </router-link>
            </nav-bar-item>
        </div>
        <div class="flex-1 items-stretch flex justify-end">
            <nav-bar-item
                type="flex justify-center w-[90px]"
                @click.prevent="goSpoplus"
            >
                <SpoPlusTopIcon />
                <span class="font-bold menu-text ml-1">SPO+</span>
            </nav-bar-item>
            <!-- <nav-bar-item
                type="flex justify-center w-[90px]"
            >
                <router-link
                    to="/event-list"
                    class="inline-block items-center flex h-full"
                >
                    <span class="font-bold menu-text">イベント</span>
                </router-link>
            </nav-bar-item> -->
            <nav-bar-item
                type="flex justify-center w-[90px]"
            >
                <router-link
                    to="/information"
                    class="inline-block items-center flex h-full"
                >
                    <span class="font-bold menu-text">お知らせ</span>
                </router-link>
            </nav-bar-item>
            <nav-bar-item
                type="flex justify-center w-[120px]"
                @click="toggleSidebar"
            >
                <span class="font-bold menu-text items-center flex">チーム活動履歴</span>
            </nav-bar-item>
            <nav-bar-item
                type="flex member-name ml-2"
            >
                <close-on-click-outside
                    :state="showLoginUser"
                    class="block font-normal cursor-pointer"
                    @click-to-close="toggleLoginUser"
                >
                    <!-- TODO: URL別途修正 -->
                    <div
                        class="flex border-2 rounded pt-2 pb-1 px-3 text-ns-sm font-semibold cursor-pointer"
                        @click="toggleLoginUser(!showLoginUser)"
                    >
                        {{ overLengthUserName(5) ? userName.substring(0,5) : userName }}<span
                            v-if="overLengthUserName(5)"
                        >&nbsp;...</span>
                        <dropdown-icon
                            class="mt-3 ml-2"
                        />
                    </div>
                    <div
                        v-show="showLoginUser"
                        class="z-[2] w-96 mt-1 p-4 text-ns-sm rounded-lg shadow-lg bg-white border absolute right-0"
                    >
                        <div class="flex justify-end">
                            <close-icon
                                stroke-color="#000000"
                                class="cursor-pointer"
                                @click="toggleLoginUser(!showLoginUser)"
                            />
                        </div>
                        <div class="flex mb-3">
                            <user-icon
                                class="border-2 h-10 w-10 mt-1 mr-3"
                            />
                            <div>
                                <div class="mb-1 text-ns-sm font-semibold cursor-pointer">
                                    {{ overLengthUserName(18) ? userName.substring(0,18) : userName }}<span
                                        v-if="overLengthUserName(18)"
                                    >...</span>
                                </div>
                                <div class="text-xs cursor-pointer font-NotoSansRegular">
                                    {{ overLengthTeamName ? teamName.substring(0,21) : teamName }}<span
                                        v-if="overLengthTeamName"
                                    >...</span>
                                </div>
                            </div>
                        </div>
                        <!-- TODO: URL別途修正 -->
                        <a href="/top/#/profile">
                            <div class="border p-3 mb-3 rounded text-ns-sm font-semibold cursor-pointer">
                                <div class="flex justify-between">
                                    <div class="flex">
                                        <user-icon
                                            class="mt-1 mr-3"
                                        />
                                        Spo＋プロフィール
                                    </div>
                                    <open-new-window
                                        class="mt-1"
                                    />
                                </div>
                            </div>
                        </a>
                        <div
                            class="flex border p-2 mt-1 rounded text-ns-sm font-semibold cursor-pointer"
                            @click="logout"
                        >
                            <logout-icon
                                class="mt-1 mr-3"
                            />
                            <div class="mt-1">
                                ログアウト
                            </div>
                        </div>
                    </div>
                </close-on-click-outside>
            </nav-bar-item>
        </div>
    </nav>
</template>

<script>
import CloseIcon from '@/assets/img/CloseIcon'
import DropdownIcon from '@/assets/img/DropdownIcon'
import LogoutIcon from '@/assets/img/LogoutIcon'
import OpenNewWindow from '@/assets/img/OpenNewWindow'
import UserIcon from '@/assets/img/UserIcon'
import CloseOnClickOutside from '@/components/Utilities/CloseOnClickOutside'
import Icon from '@/components/Utilities/Icon'
import NavBarItem from '@/components/Utilities/NavBarItem'
import { mdiLogout, mdiMenu } from '@mdi/js'
import { LocalStorage } from 'ttl-localstorage'
import { computed, inject, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import SpoPlusTopIcon from '../../assets/img/SpoPlusTopIcon.vue'

export default {
    name: 'NavBar',
    components: {
        NavBarItem,
        CloseOnClickOutside,
        // Icon,
        SpoPlusTopIcon,
        CloseIcon,
        UserIcon,
        DropdownIcon,
        LogoutIcon,
        OpenNewWindow,
    },
    setup () {
        const store = useStore()
        const router = useRouter()
        // const $http = inject('$http')
        const $swal = inject('$swal')

        const isNavBarVisible = computed(() => !store.state.isFullScreen)
        const isAsideMobileExpanded = computed(() => store.state.isAsideMobileExpanded)
        /* const userName = computed(() => store.state.userName + ' さん') */
        const userName = computed(() => store.state.userName)
        const overLengthUserName = computed(() => (len) => {
            return userName.value
                ? userName.value.length > len
                : false
        })
        const teamName = computed(() => store.state.teamName)
        const overLengthTeamName = computed(() => {
            return teamName.value
                ? teamName.value.length > 21
                : false
        })

        const showLoginUser = ref(false)
        const toggleLoginUser = (flag = true) => {
            showLoginUser.value = !!flag
        }

        const menuToggleMobileIcon = mdiMenu

        const menuToggleMobile = () => store.dispatch('asideMobileToggle')

        const menuOpenLg = () => {
            store.dispatch('asideLgToggle', true)
        }

        const logout = () => {
            $swal.fire({
                text: 'ログアウトしますか？',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: 'rgba(239,186,99,0.91)',
                confirmButtonText: 'はい',
                cancelButtonText: 'キャンセル'
            }).then((result) => {
                if (result.isConfirmed) {
                    LocalStorage.clear()
                    caches.keys().then(function(cacheNames) {
                        return Promise.all(
                            cacheNames.filter(function(cacheName) {
                                // Return true if you want to remove this cache,
                                // but remember that caches are shared across
                                // the whole origin
                            }).map(function(cacheName) {
                                return caches.delete(cacheName)
                            })
                        )
                    })
                    navigator.serviceWorker.getRegistrations()
                        .then(registrations => {
                            registrations.forEach(registration => {
                                registration.unregister()
                            })
                        })
                    window.location.href = '/top/'
                }
            })
        }

        const goSpoplus = () => {
            window.location.href = '/top/'
        }

        const toggleSidebar = () => store.dispatch('activityMobileToggle')

        return {
            isNavBarVisible,
            isAsideMobileExpanded,
            userName,
            menuToggleMobileIcon,
            menuToggleMobile,
            menuOpenLg,
            mdiMenu,
            mdiLogout,
            logout,
            goSpoplus,
            toggleSidebar,
            overLengthUserName,
            showLoginUser,
            toggleLoginUser,
            teamName,
            overLengthTeamName
        }
    }
}
</script>

<style>

.menu-text{
    color: #111827;
    text-align: center;
    font-family: Noto Sans JP;
    font-size: 14px !important;
    font-style: normal;
    font-weight: 500 !important;
    line-height: normal;
}

.member-name {
    margin-right: 50px;
}

</style>
